/**
 * What a trainer uses on the shared iPad. The server is the boundary (a kiosk session is
 * authorised as HeroTrainer, never Manager or Admin, and the Command Center and PIN/code admin
 * commands answer `Not available on the kiosk.`); this only keeps the screen from offering
 * doors that would be refused. An allowlist, so a new tile is hidden on the kiosk until someone
 * decides it belongs there.
 */
export const KIOSK_ALLOWED_PATHS = new Set([
    '/hero-trainer-center',
    '/training',
    '/training/continue',
    '/troubleshooting',
    '/tasks',
    '/hero-trainer-daily-report',
    '/bug-reporting',
    '/incident-reporting',
    '/knowledge-base',
    '/helpful-links',
    '/chatwithai',
]);

/** Pages a trainer reaches from inside those: shift flows and SOP walks, guides, lessons, issue pages. */
const KIOSK_ALLOWED_PREFIXES = ['/shift-flow/', '/guides/', '/training/', '/troubleshooting/'];

export const isKioskPathAllowed = (path) =>
    KIOSK_ALLOWED_PATHS.has(path) || KIOSK_ALLOWED_PREFIXES.some((prefix) => String(path).startsWith(prefix));

export const filterForKiosk = (items) => items.filter((item) => KIOSK_ALLOWED_PATHS.has(item.to));
